import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryCategories } from '@/renderer/services/inventoryItemService';

export function useInventoryCategories(companyId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.inventory.categories(companyId ?? 0),
    queryFn: async () => {
      const result = await fetchInventoryCategories(companyId ?? 0);
      if (!result.success) {
        throw new Error(result.error ?? 'Failed to fetch inventory categories');
      }

      return result.data ?? [];
    },
    enabled: !!companyId,
  });
}
